import { createStore } from "vuex";
import instanceModule from "@/store/instance";
import registrationModule from "@/store/registration";
import authModule from "@/store/auth";
import paymentModule from "@/store/payment";

import { createLogger } from "vuex";
import { IUrl } from "@/interfaces/IUrl";

const debug = process.env.NODE_ENV !== "production";
const plugins = debug ? [createLogger({})] : [];

const url: IUrl = window as never;

export default createStore({
	state: {
		userId: 1,
		urls: url.urls,
	},
	getters: {},
	mutations: {},
	actions: {},
	modules: {
		instanceModule,
		registrationModule,
		authModule,
		paymentModule,
	},
	plugins,
});
